export enum PricingSummaryLineItemType {
  MODULE = `MODULE`,
  INVERTER = `INVERTER`,
  ENERGY_BACKUP = `ENERGY_BACKUP`,
  ADDITIONAL_EQUIPMENT = `ADDITIONAL_EQUIPMENT`,
  OPTIMIZER = `OPTIMIZER`,
  EQUIPMENT = `EQUIPMENT`,
  INCENTIVE = `INCENTIVE`,
  HARDCODED_ADDER = `HARDCODED_ADDER`,
  ADDER = `ADDER`,
  FEE = `FEE`,
  MARGIN = `MARGIN`,
  REBATE = `REBATE`,
  WARRANTY = `WARRANTY`,
  DEALER_FEE = `DEALER_FEE`,
  DISCOUNT = `DISCOUNT`,
  DOWN_PAYMENT = `DOWN_PAYMENT`,
  SALES_TAX = `SALES_TAX`,
  GENERAL_EXCISE_TAX = `GENERAL_EXCISE_TAX`,
  EV_OUTLET = `EV_OUTLET`,
  EV_CHARGER = `EV_CHARGER`,
  ROOFING = `ROOFING`,
  POWUR_LENDER_MARGIN_FEE = `POWUR_LENDER_MARGIN_FEE`,
}

export type SystemPricingItem = {
  id: string
  name: string
  type: string
  price: string
  total: string
  children?: SystemPricingItem[] | undefined
  required?: boolean
  accessor?: string
}

export type PricingSummaryLineItem = {
  cost: number
  children: PricingSummaryLineItem[]
  displayName: string
  powurOsId: number | null
  quantity: number
  subType: string | null
  taxable: boolean
  type: string
}

export function costOfLineItem(item: PricingSummaryLineItem): number {
  return (
    item.cost * item.quantity +
    item.children.reduce((sum, child) => sum + costOfLineItem(child), 0)
  )
}
